import { render, staticRenderFns } from "./SelectYesNo.vue?vue&type=template&id=456f4938"
import script from "./SelectYesNo.vue?vue&type=script&lang=js"
export * from "./SelectYesNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports